


import styled from 'styled-components';

export const StyledP = styled.p`
  padding: 1rem 1rem 1rem 0;
`;
